
import { defineStore } from 'pinia'

export const useOAuthStore = defineStore('oauth', {
  state: () => {
    return {
      token: localStorage.getItem('token') || '', // 从 localStorage 获取 token
    }
  },
  actions: {
    // 设置 token 并存储到 localStorage
    setToken(newToken: string) {
      this.token = newToken
      localStorage.setItem('token', newToken)
    },
    // 清除 token
    clearToken() {
      this.token = ''
      localStorage.removeItem('token')
    }
  }
})
